/**
 * 时间轴驱动器
 * 控制时间轴的时间状态, 根据播放状态获取当前时间, 并从时间轴中获取弹幕
 */
var TimelineDriver = /** @class */ (function () {
    function TimelineDriver(_a) {
        var timeline = _a.timeline, getTime = _a.getTime, onCurrentDanmaku = _a.onCurrentDanmaku;
        /** 播放状态 */
        this.isPlaying = false;
        this.timeline = timeline;
        this.getTime = getTime;
        this.seconds = 0;
        this.milliseconds = 0;
        this.onCurrentDanmaku = onCurrentDanmaku || (function () { });
    }
    /** 时间轴跳转 */
    TimelineDriver.prototype.seek = function () {
        var time = this.getTime();
        this.seconds = Math.floor(time / 1000);
        this.milliseconds = time % 1000;
        return this.timeline.getSeekList(time);
    };
    /** 播放 */
    TimelineDriver.prototype.play = function () {
        var _this = this;
        if (!this.isPlaying) {
            this.isPlaying = true;
            this.timeoutTimer = window.setTimeout(function () {
                _this.seconds++; // 等待至该秒结束, 进入下一秒段
                _this.intervalTimer = window.setInterval(function () {
                    _this.emitCurrentDanmaku(_this.timeline.getNextList(_this.seconds));
                    _this.seconds++;
                }, 1000);
                _this.milliseconds = 0;
                window.clearTimeout(_this.timeoutTimer);
            }, 1000 - this.milliseconds);
        }
    };
    /** 暂停 */
    TimelineDriver.prototype.pause = function () {
        if (this.isPlaying) {
            this.isPlaying = false;
            window.clearTimeout(this.timeoutTimer);
            window.clearInterval(this.intervalTimer);
            this.milliseconds = this.getTime() - this.seconds * 1000;
        }
    };
    TimelineDriver.prototype.emitCurrentDanmaku = function (list) {
        this.onCurrentDanmaku(list);
    };
    return TimelineDriver;
}());
export { TimelineDriver };
//# sourceMappingURL=TimelineDriver.js.map